import React, { useEffect, useRef } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import zohoService from '../../../services/zohoService';
import { toast } from 'react-toastify';

const ZohoRedirect = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const isProcessing = useRef(false);

    useEffect(() => {
        const handleAuthorization = async () => {
            // Prevent multiple calls
            if (isProcessing.current) {
                return;
            }
            isProcessing.current = true;

            try {
                const code = searchParams.get('code');
                if (!code) {
                    throw new Error('Authorization code not found');
                }

                // Call your API to handle the authorization
                const response = await zohoService.getAccessToken({ code });
                
                toast.success('Zoho authorization successful', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });

                // Redirect back to Xero settings page
                navigate('/zoho_settings');
            } catch (error) {
                console.error('Authorization error:', error);
                toast.error(error.message || 'Failed to authorize Zoho', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
                navigate('/zoho_settings');
            }
        };

        handleAuthorization();
    }, [searchParams, navigate]);

    return (
        <div className="d-flex justify-content-center align-items-center p-5">
            <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
            <div className="ms-3">
                <h5 className="mb-0">Authorizing Zoho...</h5>
                <small className="text-muted">Please wait while we authorize Zoho</small>
            </div>
        </div>
    );
}

export default ZohoRedirect;    